import MuiContainer, { type ContainerProps } from "@mui/material/Container";

export type { ContainerProps };

export const Container = MuiContainer;
